<template>
    <page>
        <module title="限时折扣活动详情">
            <div v-if="activityInfo">
                <c-detail title="基础信息">

                    <c-detail-item label="活动名称">{{activityInfo.activity_name}}</c-detail-item>

                    <c-detail-item label="活动时间">{{activityInfo.begin_date}} 至 {{activityInfo.end_date}}</c-detail-item>

                    <c-detail-item label="活动状态">
                        <template v-slot="{data}">
                            <span v-if="activityInfo.start_state == 0" style="color:#999">未开始</span>
                            <span v-if="activityInfo.start_state == 1" style="color:dodgerblue">进行中</span>
                            <span v-if="activityInfo.start_state == 2" style="color:red">已结束</span>
                        </template>
                    </c-detail-item>

                    <c-detail-item label="启/禁用状态">
                        <template v-slot="{data}">
                            <span v-if="activityInfo.state == 1" style="color:darkgray">禁用</span>
                            <span v-if="activityInfo.state == 2" style="color:green">启用</span>
                        </template>
                    </c-detail-item>

                    <c-detail-item label="活动标签">{{activityInfo.tags}}</c-detail-item>

                    <c-detail-item label="活动预告">
                        <template v-slot="{data}">
                            <span v-if="activityInfo.activity_notice == -1" style="color:gray">不预告</span>
                            <span v-if="activityInfo.activity_notice == 0" style="color:blue">立即预告</span>
                            <span v-if="activityInfo.activity_notice == 1">提前<span style="color:red">{{activityInfo.activity_notice_time}}</span>小时预告</span>
                        </template>
                    </c-detail-item>

                    <c-detail-item label="商品参加方式">{{rangeTypeMap[activityInfo.commodity_range]}}</c-detail-item>

                    <c-detail-item label="销售情况">
                        <span>已下<span style="color:red">{{activityInfo.order_count}}</span>个订单</span>；
                        <span>共<span style="color:red">{{activityInfo.product_count}}</span>件商品</span>

                    </c-detail-item>

                    <c-detail-item label="是否支持定制" v-if="systemConfig.product_custom == 'ON'">{{isCustomMap[activityInfo.is_custom]}}</c-detail-item>

                    <c-detail-item label="活动说明" full>{{activityInfo.activity_remark}}</c-detail-item>

                    <c-detail-item label="活动商品" v-show="activityInfo.commodity_range == 1" full>
                        <c-table v-model="productList" height="auto" border>
                           <c-table-column
                                    label="商品信息"
                                    name="product_name"
                                    width="200"
                            >
                                <template v-slot="{data}">
                                    <div class="flex-center">
                                        <c-image :src="data.product_img_url" size="46" preview></c-image>
                                        <p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                                            <span v-if="data.product_itemnumber">{{data.product_itemnumber}} - </span>
                                            {{data.product_name}}
                                        </p>
                                    </div>
                                </template>
                          </c-table-column>

                          <c-table-column
                              label="原价"
                              name="sale_price"
                              width="80"
                          >
                            <template v-slot="{data}">
                              ￥{{data.product_price_min}}
                              <span v-if="data.product_price_max"> - ￥{{data.product_price_max}}</span>
                            </template>
                          </c-table-column>

                          <c-table-column
                              label="活动折扣"
                              width="140"
                              name="activity_discount"
                          >
                            <template v-slot="{data}">
                              <span v-if="data.activity_discount">{{ data.activity_discount }}折</span>
                            </template>
                          </c-table-column>

                          <c-table-column
                                label="促销价"
                                name="promotion_price"
                                width="80"
                            >
                                <template v-slot="{data}">
                                    <span v-if="data.activity_discount">
                                     ￥{{parseFloat(data.product_price_min * data.activity_discount / 10).toFixed(2)}}
                                      <span v-if="data.product_price_max">
                                          - ￥{{parseFloat(data.product_price_max * data.activity_discount / 10).toFixed(2)}}
                                      </span>
                                    </span>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="活动销量(总数)"
                                    name="sale_count"
                                    width="80"
                            >
                            </c-table-column>

                            <c-table-column
                                    label="商品状态"
                                    name="state"
                                    width="80"
                            >
                                <template v-slot="{data}">
                                    <span v-if="data.state == 1" style="color:red">禁用</span>
                                    <span v-if="data.state == 2" style="color:green">启用</span>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-detail-item>

                    <c-detail-item label="活动品牌" v-show="activityInfo.commodity_range == 2" full>
                        <c-table v-model="brandList" height="auto" border>

                            <c-table-column
                                    label="品牌名称"
                                    name="brand_name"
                                    width="200"
                            ></c-table-column>

                            <c-table-column
                                    label="折扣"
                                    width="140"
                                    name="activity_discount"
                            >
                                <template v-slot="{data}">
                                    <span v-if="data.activity_discount">{{ data.activity_discount }}折</span>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="品牌状态"
                                    name="state"
                                    width="80"
                            >
                                <template v-slot="{data}">
                                    <span v-if="data.state == 0" style="color:red">结束</span>
                                    <span v-if="data.state == 1" style="color:green">正常</span>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-detail-item>

                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'limit_time_discount_detail',

        props: {
            id: String
        },

        data() {
            return {
                activityInfo: '',
                productList: [],
                brandList: [],
                showTypeMap: {'1':'列表模式','2':'大图模式'},
                rangeTypeMap: {'1':'指定商品','2':'指定品牌'},
                isCustomMap: {'0':'不支持','1':'支持'}
            }
        },

        computed: {
            ...mapState(['dict']),
	        ...mapState(['systemConfig'])
        },

        watch: {
            id() {
                this.getActivityDetail();
            }
        },

        mounted() {
            this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activitySale/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.activityInfo = data;
                        this.productList = data.product_list;
                        this.brandList = data.brand_list;
                    }
                });
            },
            //改变启禁状态
            over(row,state){
                row.data.state = state;
            },
        }
    }
</script>